export default __webpack_public_path__ + "static/media/promo-travel.0ee6dfcc.jpg";